export default __webpack_public_path__ + "static/media/calendar2-event.9699968f.svg";